import "./footerResults.sass";

export default function FooterResults({ data }) {

  const { liga, period_title, class: claseGame } = data;

  return (
    <div className="results__footer">
      {claseGame === "clarosports-in-progress-game"
        ?
        <div className="results__footer-status">
          <p >EN VIVO {period_title}´</p>
        </div>
        :
        <div className="results__footer-league">
          <p >{liga}</p>
        </div>
      }
    </div>
  )
}